import { Modal } from './modal';
import { ID } from '../../const';

export class ActiveModalFacotry {
	static new(): KnockoutObservable<Modal> {
		let obs = ko.observable<Modal>();
		obs.subscribe(modal => {
			if (modal) {
				setTimeout(() => {
					modal.show();
				});
			}
		});
		return obs;
	}
}
export class ModalUtil {
	static count: number = 0;
	static overlayElement: JQuery;
	static overlayVisible: KnockoutObservable<boolean>;
	static activeModal: KnockoutObservable<Modal> = ActiveModalFacotry.new();
	static getNewId(): string {
		this.count++;
		return ID.Modal.concat('_', this.count.toString());
	}
	static overlay(on: boolean = true) {
		if (on) {
			this.getOverlay().show();
		} else {
			this.getOverlay().hide();
		}
	}
	static getOverlay(): JQuery {
		if (this.overlayElement) {
			return this.overlayElement;
		}
		return (this.overlayElement = $('<div class="overlay"></div>').appendTo(document.body));
	}
	static chain(modal: Modal) {
		let activeModal: Modal;
		if ((activeModal = this.activeModal())) {
			activeModal.hide();
			var handler = () => {
				this.overlay();
				this.activeModal(activeModal);
				modal.Closed.unsubscribe(handler);
			};
			modal.Closed.subscribe(handler);
			this.activeModal(modal);
		} else {
			this.activeModal(modal);
			var handler = () => {
				modal.Closed.unsubscribe(handler);
				this.activeModal(null);
			};
			modal.Closed.subscribe(handler);
		}
	}
}
